module.exports = __webpack_public_path__ + "static/media/marketplace.97c5bf0c.svg";